import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Panel, SectionLabel } from '@/ui';
import { useCommunities } from '@/hooks';
import { CommunityIcon } from '../CommunityIcon';

const List = styled.ul`list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 10px;`;
const Row = styled(Link)`display: flex; align-items: center; gap: 10px; text-decoration: none;`;
const Name = styled.span`font-family: ${({ theme }) => theme.font.body}; font-weight: 600; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textPrimary};`;
const Sub = styled.span`font-family: ${({ theme }) => theme.font.mono}; font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted};`;
const Info = styled.div`display: flex; flex-direction: column;`;
const Empty = styled.p`margin: 0; font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted};`;

export function MyCommunitiesPanel() {
  const { joined } = useCommunities();
  return (
    <Panel>
      <SectionLabel as="h2">My Communities</SectionLabel>
      {joined.length === 0 ? (
        <Empty>You haven&apos;t joined any communities yet.</Empty>
      ) : (
        <List>
          {joined.map((c) => (
            <li key={c.id}>
              <Row to={`/communities/${c.id}`}>
                <CommunityIcon svg={c.icon} size={34} />
                <Info><Name>{c.name}</Name><Sub>{c.members}</Sub></Info>
              </Row>
            </li>
          ))}
        </List>
      )}
    </Panel>
  );
}
